/**
 * Created by roi on 2/05/17.
 */

import { OBSERVACIO_OBTENIR, OBSERVACIO_OBTENIR_EN_CURS,
    OBSERVACIO_INICIALITZAR } from '../../actions/actionTypes';

const ESTAT_INICIAL_OBSERVACIONS = { carregant: false };

const totes = (state = ESTAT_INICIAL_OBSERVACIONS, action) => {
    switch (action.type) {
        case OBSERVACIO_OBTENIR:
            return {
                ...action.dadesObservacions,
                carregant: false
            };

        case OBSERVACIO_OBTENIR_EN_CURS:
            return {
                ...state,
                carregant: true
            };

        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_OBSERVACIONS;

        default:
            return state;
    }
};

export default totes;



// WEBPACK FOOTER //
// ./src/reducers/observacio/totes.js